export default function SvgClose3() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12px"
          cursor="pointer"
          fill="#000"
          version="1.1"
          viewBox="0 0 40 40"
          xmlSpace="preserve"
          >
          <path d="M21.414 20L33.207 8.207a.999.999 0 10-1.414-1.414L20 18.586 8.207 6.793a.999.999 0 10-1.414 1.414L18.586 20 6.793 31.793a.999.999 0 101.414 1.414L20 21.414l11.793 11.793a.997.997 0 001.414 0 .999.999 0 000-1.414L21.414 20z"></path>
        </svg>
      </>
    );
  }
